import React, { useRef, useState, useEffect } from 'react';
import { useClickOutside } from '../../hooks/ui';
export const Modal = ({ id, component: Component, componentProps, isOpen, onClose, }) => {
    const ref = useRef(null);
    const [closing, setClosing] = useState(false);
    // Handle clicks outside the modal content
    useClickOutside(ref, () => {
        if (isOpen) {
            setClosing(true);
            onClose();
        }
    });
    /**
     * Effect to handle escape key press
     * Adds and removes event listener for keydown events
     */
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
                setClosing(true);
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscKey);
        }
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isOpen, onClose]);
    if (!isOpen)
        return null;
    return (React.createElement("div", { id: id, className: "modal-container", style: { display: 'flex' } },
        React.createElement("div", { ref: ref, className: "modal-content" },
            React.createElement(Component, { ...componentProps, closing: closing, setClosing: setClosing }))));
};
